import Spinner from '@rio-cloud/rio-uikit/Spinner';

export const LoadingIndicator = (): JSX.Element => (
    <div data-testid="loading-spinner" className={'display-flex justify-content-center'}>
        <Spinner />
    </div>
);
